<template>
    <div class="steps">
        <div class="steps_content" ref="steps" v-if="status && currentStatus">
                <template v-for="item in status">
                    <template v-if="item.num <= currentStatus">
                        <div class="content" :key="item.num">
                            <img v-if="currentStatus > item.num" src="../images/end.svg" alt="" >
                            <div class="num" v-text="item.num" v-else></div>
                            <p v-text="item.content"></p>
                        </div>
                    </template>
                    <div v-else :class="item.num == currentStatus ? 'content' : 'noStatus'"  :key="item.num">
                        <div class="num" v-text="item.num"></div>
                        <p v-text="item.content"></p>
                    </div>
                </template>
                <!-- {{currentStatus}} -->
                <div class="line" :class="currentStatus > 1 ? 'stepPending' : ''"></div>
                <div class="line1" :class="currentStatus > 1 ? 'stepPending' : ''"></div>
        </div> 
    </div>
</template>
<script>
export default {
    props: {
        status: {
            type: Array,
            default: function() {
                return [{
                    num: 1,
                    content: '123'
                },{
                    num: 2,
                    content: '123'
                },{
                    num: 3,
                    content: '123'
                }]
            } 
        },
        currentStatus: {
            type: Number,
            default: 1,
        },
    },
    methods: {
        // changeWidth(value,data) {
        //     let length = data.length;
        //     var num = ''
        //     if(length === 2) {
        //         return `width:824px; background:#4066d4`
        //     }else if(length === 3) {
        //         switch(value) {
        //             case 1 :{
        //                 num = '0'
        //                 break
        //             }
        //             case 2 :{
        //                 num = 824/2
        //                 break
        //             }
        //             case 3 :{
        //                 num = 824/1
        //                 break
        //             }
        //         }
        //         return `width:${num}px; background:#4066d4`
                
        //     }else if(length === 4) {
        //         switch(value) {
        //             case 1 :{
        //                 num = 824/3
        //                 break
        //             }
        //             case 2 :{
        //                 num = 824/1.5
        //                 break
        //             }
        //             case 3 :{
        //                 num = 824/1
        //                 break
        //             }
        //         }
        //         return `width:${num}px; background:#4066d4`
        //     }
        //     else if(length === 5) {
        //         switch(value) {
        //             case 1 :{
        //                 num = 824/4
        //                 break
        //             }
        //             case 2 :{
        //                 num = 824/2
        //                 break
        //             }
        //             case 3 :{
        //                 num = 824/1.3
        //                 break
        //             }
        //             case 4 :{
        //                 num = 824/1
        //                 break
        //             }
        //         }
        //         return `width:${num}px; background:#4066d4`
        //     }
        // }
    },
}
</script>

<style scoped lang='scss'>
.stepPending {
    background: #4066D4 !important;
}
.steps {
    width: 100%;
    display: flex;
    justify-content: center;
    .steps_content {
        width: 940px;
        height: 64px;
        display: flex;
        text-align: center;
        position: relative;
        align-items: center;
        justify-content: space-between;
        .content {
            display: flex;
            align-items: center;
            .num {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                font-weight: bold;
                font-size: 12px;
                font-weight: bold;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #4066D4;
            }
            p {
                font-family: 'Open Sans';
                font-size: 14px;
                margin-left: 8px;
                font-weight: 700;
            }
        
        }
        
        .success {
            width: 32px;
            height: 24px;
            position: relative;
            z-index: 200;
            text-align: center;
            line-height: 24px;
            text-align: center;
            background: #fff;
            p {
                width: 124px;
                text-align: center;
                // margin-top: 6px;
                font-weight: 500;
                font-size: 14px;
                position: absolute;
                left: -45px;
            }
        }
        .noStatus {
            display: flex;
            align-items: center;
            .num {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                font-weight: bold;
                font-size: 12px;
                font-weight: bold;
                /* background: #B2B6C0; */
                border: 2px solid #DADCE1;
                color: #7F8596;
            }
            p {
                color: #dadce1;
                font-family: 'Open Sans';
                font-size: 14px;
                margin-left: 8px;
                color: #7F8596;
                font-weight: 700;
            }
        }
        .line {
                width: 319px;
                height: 2px;
                position: absolute;
                left: 120px;
                background: #dadce1;
            &1 {
                width: 319px;
                height: 2px;
                position: absolute;
                right: 80px;
                background: #dadce1;
            }
        }
    }
}

</style>
